module.exports = __webpack_public_path__ + "img/special-game-card-mozgo-logo.e2aa0433.svg";